import { Component } from "@angular/core";

@Component({
    templateUrl: 'app-shell.component.html'
})
export class AppShellComponent { }